
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store, StoreMutations, FiltriReintegri } from '@/store';
import dayjs from 'dayjs';

@Component
export default class OpzioniReintegri extends Vue {

    @Watch("$store.state.ui.opzioniVisibili")
    onOpzioniOpened(isOpenNew: boolean, isOpenOld: any) {
        if(isOpenNew && isOpenNew != isOpenOld) {
            // caricamento filtro corrente
            this.filtroIdDistinta = store.state.uiReintegri.filtri.idDistintaStatica;
            this.filtroDataInserimentoDa = store.state.uiReintegri.filtri.dataInserimentoDa;
            this.filtroDataInserimentoA = store.state.uiReintegri.filtri.dataInserimentoA;
        }
    }
    private menu1: boolean=false;
    private menu2: boolean=false;

    private filtroIdDistinta: string = '';
    private date: string = '';
    private filtroDataInserimentoDa: string = '';
    private filtroDataInserimentoDaFormatted: string = '';
    private filtroDataInserimentoA: string = '';
    private filtroDataInserimentoAFormatted: string = '';

   private annullaModificaFiltro() {
        store.commit(StoreMutations.SetOpzioniVisibili, false);
    }

    private applicaModificaFiltro() {
        // TODO
        let filtri: FiltriReintegri = {
            idDistintaStatica: this.filtroIdDistinta,
            dataInserimentoDa: this.filtroDataInserimentoDa,
            dataInserimentoA: this.filtroDataInserimentoA
        }
        store.commit(StoreMutations.SetFiltriReintegri, filtri);
        store.commit(StoreMutations.SetOpzioniVisibili, false);
    }

    private svuotaFiltro() {
        this.filtroIdDistinta = '';
        this.filtroDataInserimentoDa= '';
        this.filtroDataInserimentoA= '';
        this.filtroDataInserimentoDaFormatted='';
        this.filtroDataInserimentoAFormatted='';
    }
//#region gestione negoziazione data
@Watch('filtroDataInserimentoDa')
    onDateChange(): void {
        this.filtroDataInserimentoDaFormatted = this.formatDate(this.filtroDataInserimentoDa)
    }
@Watch('filtroDataInserimentoA')
    onDataAChange(): void {
        this.filtroDataInserimentoAFormatted = this.formatDate(this.filtroDataInserimentoA)
    }
    formatIsoDate(date: string): string {
        if (!date) return '';

        return dayjs(date).format('DD/MM/YYYY');
    }
    formatDate (date: string): string {
        if (!date) return '';

        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
    }

    parseDate (date: string): string {
        if (!date) return '';

        const [day, month, year] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    //#endregion gestione negoziazione data
}

